module.exports = __webpack_public_path__ + "static/media/Event-04.748fc684.svg";